// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1UkKJ","right":"styles_right__-fL8G"};